import slider from "/assets/scripts/slider.js";
import extra from "/assets/scripts/extra.js";
import cookies from "/assets/scripts/cookies.js";
import forms from "/assets/scripts/forms.js";
import animation from "/assets/scripts/animation.js";

document.addEventListener("DOMContentLoaded", function () {
  slider();
  extra();
  cookies();
  forms();
  animation();
});
